import { render, staticRenderFns } from "./stack-column.md?vue&type=template&id=7776bf72&"
import script from "./stack-column.md?vue&type=script&lang=js&"
export * from "./stack-column.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7776bf72')) {
      api.createRecord('7776bf72', component.options)
    } else {
      api.reload('7776bf72', component.options)
    }
    module.hot.accept("./stack-column.md?vue&type=template&id=7776bf72&", function () {
      api.rerender('7776bf72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Column/stack-column.md"
export default component.exports